import cssPropertyNoUnknown from './css-property-no-unknown/index.js'
import fontWeightNoIgnoredValues from './font-weight-no-ignored-values/index.js'
import lineHeightNoValueWithoutUnit from './line-height-no-value-without-unit/index.js'
import stylePropertyNoUnknown from './style-property-no-unknown/index.js'

export default {
  'font-weight-no-ignored-values': fontWeightNoIgnoredValues,
  'css-property-no-unknown': cssPropertyNoUnknown,
  'style-property-no-unknown': stylePropertyNoUnknown,
  'line-height-no-value-without-unit': lineHeightNoValueWithoutUnit
}
